export function darkenColor(hexColor: string | undefined | null, factor: number = 0.5): string | undefined {
  if (!hexColor) return undefined;
  
  let hex = hexColor.replace('#', '');
  
  if (hex.length === 3) {
    hex = hex[0] + hex[0] + hex[1] + hex[1] + hex[2] + hex[2];
  }
  
  if (hex.length !== 6) return hexColor;
  
  const r = parseInt(hex.substring(0, 2), 16);
  const g = parseInt(hex.substring(2, 4), 16);
  const b = parseInt(hex.substring(4, 6), 16);
  
  if (isNaN(r) || isNaN(g) || isNaN(b)) return hexColor;
  
  const darkR = Math.round(r * factor);
  const darkG = Math.round(g * factor);
  const darkB = Math.round(b * factor);
  
  const toHex = (n: number) => n.toString(16).padStart(2, '0');
  
  return `#${toHex(darkR)}${toHex(darkG)}${toHex(darkB)}`;
}
